var map = {
	"./arrow-next.svg": 8773,
	"./arrow-previous.svg": 62493,
	"./arrow.svg": 35953,
	"./article.svg": 78244,
	"./breadcrumbs-bullet.svg": 6997,
	"./check.svg": 42714,
	"./chevron-down.svg": 8192,
	"./close-tag.svg": 19553,
	"./close.svg": 39318,
	"./controls.svg": 97232,
	"./download.svg": 31890,
	"./external-link.svg": 90240,
	"./form-status/form-error.svg": 64161,
	"./form-status/form-redirect.svg": 96665,
	"./form-status/form-success.svg": 54498,
	"./globe.svg": 56513,
	"./info.svg": 61770,
	"./infomaniak.svg": 53579,
	"./insider.svg": 53688,
	"./lock.svg": 92227,
	"./logo/logo-cafe.svg": 83639,
	"./logo/logo-mjaf.svg": 77340,
	"./logo/logo-mjf.svg": 82097,
	"./logo/logo-superhuit.svg": 31459,
	"./menu-back.svg": 72765,
	"./menu-close.svg": 2360,
	"./menu.svg": 7867,
	"./micro.svg": 87270,
	"./more.svg": 87165,
	"./note.svg": 93286,
	"./play.svg": 97440,
	"./plectrum.svg": 38306,
	"./prohibited.svg": 51676,
	"./search.svg": 46490,
	"./social/facebook.svg": 35326,
	"./social/instagram.svg": 4522,
	"./social/linkedin.svg": 86508,
	"./social/tiktok.svg": 26412,
	"./social/twitter.svg": 85851,
	"./social/x.svg": 55390,
	"./social/youtube.svg": 97265,
	"./sun.svg": 33864,
	"./superhuit.svg": 84041,
	"./swisstopevents.svg": 70875,
	"./wave.svg": 80613
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70877;